/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconEditFilled8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconEditFilled8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.588 3.053 2.972 6.671 1.33 7 1 6.671l.329-1.644 3.62-3.616c.113-.114.17-.17.225-.212a.986.986 0 0 1 1.186 0c.055.04.112.097.226.21.115.115.172.172.213.227a.987.987 0 0 1 .002 1.19 2.481 2.481 0 0 1-.213.227Zm-.89-.04.425-.425.123-.124a.33.33 0 0 0 .03-.43L6.246 2a8.189 8.189 0 0 0-.248-.246c-.027-.026-.034-.03-.033-.03a.329.329 0 0 0-.395 0l-.034.03a8.105 8.105 0 0 0-.123.123l-.426.424.712.712Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconEditFilled12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconEditFilled12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m9.882 4.58-5.423 5.427-2.466.493-.493-.493.493-2.467 5.43-5.424c.17-.17.256-.256.337-.317a1.478 1.478 0 0 1 1.78-.002c.082.062.168.147.339.318.172.17.258.257.32.338.4.528.401 1.258.002 1.787a3.719 3.719 0 0 1-.32.34Zm-1.334-.06.637-.638.184-.186.045-.05a.494.494 0 0 0 0-.596c0 .002-.007-.01-.046-.05-.04-.042-.095-.097-.185-.186a12.197 12.197 0 0 0-.185-.183c-.04-.038-.052-.046-.05-.045a.493.493 0 0 0-.594 0c.002-.001-.01.007-.05.046-.042.04-.096.094-.185.183l-.638.637 1.067 1.067Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconEditFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconEditFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m13.176 6.106-7.231 7.236L2.657 14 2 13.342l.657-3.289 7.24-7.231c.227-.228.341-.342.45-.424.702-.53 1.67-.53 2.374-.002.109.082.223.196.451.423.23.229.344.343.427.452.534.704.535 1.677.003 2.383-.083.109-.197.223-.426.452Zm-1.779-.08.85-.85.245-.248c.051-.055.062-.07.06-.067a.658.658 0 0 0 0-.794c.001.002-.01-.013-.061-.067-.055-.057-.127-.13-.246-.248l-.248-.244c-.054-.051-.07-.062-.067-.06a.657.657 0 0 0-.79 0c.001-.001-.014.01-.067.06-.057.055-.13.127-.248.245l-.85.85 1.422 1.423Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconEditFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconEditFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.764 9.16 8.917 20.014 3.987 21 3 20.013l.986-4.933L14.845 4.233c.341-.342.512-.512.676-.636a2.957 2.957 0 0 1 3.56-.002c.164.123.335.293.677.634.344.343.516.514.64.678.801 1.056.803 2.516.005 3.573-.124.164-.296.336-.64.68Zm-2.668-.121 1.273-1.275c.178-.178.288-.288.369-.373.077-.081.093-.104.09-.1a.987.987 0 0 0 0-1.191c.002.004-.014-.019-.092-.1-.081-.085-.19-.194-.37-.372a24.66 24.66 0 0 0-.37-.366c-.082-.077-.104-.093-.1-.09a.986.986 0 0 0-1.187 0c.003-.002-.02.014-.1.091-.085.08-.193.19-.371.367l-1.276 1.274 2.134 2.135Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconEditFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconEditFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconEditFilled8 {...iconProps} />;
        case '12':
            return <IconEditFilled12 {...iconProps} />;
        case '16':
            return <IconEditFilled16 {...iconProps} />;
        case '24':
            return <IconEditFilled24 {...iconProps} />;
        default:
            return <IconEditFilled24 {...iconProps} />;
    }
});
